
const State = () => {
    return {
        'activated-route': '',
        user: {
            isAuthenticaded: true,
            data: {},
            permissions: {},
            context: { company: 'VLG', team: 'RV' }
        },
        pages: {
            pgHome: { name: 'JGA Confecções', url: '', view: false },
        }
    }
}

export default State
